$(document).ready( function() {

    // Apply scrollspy to the body element.
    $('body').scrollspy({ target: '#issue-nav' });

    // Add smooth scrolling on all links
    $("#issue-nav a, #issues-wrapper a, #back-home-link").on('click', function(event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;

            animateTo(hash);
            toggleSideBarVisibility();
        }
    });

    $(".section-content .nav-link").click( function() {
        positionSection($(this));
    });

    // Handles the behavior of the nav control links (left and right arrows to navigate goals inside an issue)
    $(".nav-controls > a").click( function(e) {
        e.preventDefault();
        var clickedControl = $(this);
        var navDirection = clickedControl.data("direction");
        var $goalNavWrapper = $(this).closest(".goal-nav-wrapper");
        var $navPillLinks = $(".nav-pills > .nav-link", $goalNavWrapper);
        var navPillActiveLinkIndex = $navPillLinks.filter(".active").index();
        var $targetNavPillLink;

        if (navDirection == "next" && navPillActiveLinkIndex < $navPillLinks.length - 1) {
            $targetNavPillLink = $($navPillLinks.get(navPillActiveLinkIndex + 1));
        }
        else if (navDirection == "previous" && navPillActiveLinkIndex > 0) {
            $targetNavPillLink = $($navPillLinks.get(navPillActiveLinkIndex - 1));
        }

        if (typeof $targetNavPillLink == "object" && $targetNavPillLink.length > 0) {
            $targetNavPillLink.tab('show');
            positionSection($(this));
        }
    });

    $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        var $parentNavPills = $(this).closest(".nav-pills");
        var $navControlPreviousLink = $parentNavPills.siblings(".nav-controls").children("a[data-direction='previous']");
        var $navControlNextLink = $parentNavPills.siblings(".nav-controls").children("a[data-direction='next']");

        if ($(e.target).index() == $parentNavPills.children(".nav-link").length - 1) {
            $navControlNextLink.removeClass();
        }
        else {
            $navControlNextLink.addClass("active");
        }

        if ($(e.target).index() == 0) {
            $navControlPreviousLink.removeClass();
        }
        else {
            $navControlPreviousLink.addClass("active");
        }

        setIssueWrapperHeight();
    });

    setHeroWrapperHeight();
    setIssueWrapperHeight();
    toggleSideBarVisibility();
});

$(window).resize( function() {
    setHeroWrapperHeight();
    setIssueWrapperHeight();
    toggleSideBarVisibility();
});

$(window).scroll( function() {
    toggleSideBarVisibility();
});


//---------- GLOBAL FUNCTIONS
function setHeroWrapperHeight() {

        var $issuesWrapper = $('#issues-wrapper');

        if ($(window).width() > 768) {
            var offset = 40;
            var headingsHeight = $('#headings').outerHeight(true);
            var windowHeight = $(window).height();
            var headerPadding = windowHeight - $('#home').height();
            var maxSpaceForHero = windowHeight - headingsHeight - headerPadding - offset;

            if ($issuesWrapper.outerHeight(true) > maxSpaceForHero) {
                $issuesWrapper.css({ "height": maxSpaceForHero, "overflow-y": "scroll" });
            }
        }
        else {
            $issuesWrapper.css({ "height": "auto", "overflow-y": "visible" });
        }
}

function setIssueWrapperHeight() {

    var $issueWrappers = $('section.block-list');
    var windowHeight = $(window).height();
    var offset = 40;
    var maxSpaceForIssue = windowHeight - offset;

    $issueWrappers.each( function() {

        var $issueWrapper = $(this);

        if ($(window).width() > 768) {
            var issueContainerHeight = $issueWrapper.find(".section-content").first().outerHeight(true);

            if (issueContainerHeight > maxSpaceForIssue) {
                $issueWrapper.css({ "height": "auto" });
                $issueWrapper.children(".container-fluid").css({ "height": "auto" });
            }
            else {
                $issueWrapper.css({ "height": "100vh" });
                $issueWrapper.children(".container-fluid").css({ "height": "100vh" });
            }
        }
        else {
            $issueWrapper.css({ "height": "auto" });
            $issueWrapper.children(".container-fluid").css({ "height": "auto" });
        }
    });
}

function toggleSideBarVisibility() {
    var currentScrollPosition =  $(window).scrollTop();
    var headerHeight = $("#home").outerHeight(true);
    var $sideNav = $("#side-nav");

    if (currentScrollPosition > (headerHeight - 5) && $sideNav.hasClass("visible") == false) {
        $sideNav.addClass("visible");
    }
    else if (currentScrollPosition <= (headerHeight / 2) && $sideNav.hasClass("visible")) {
        $sideNav.removeClass("visible");
    }
}

function positionSection($navLink) {
    var $section = $navLink.closest("section");
    var hash = '#' + $section.attr('id');

    animateTo(hash);
}

function animateTo(hash) {
    var $hash = $(hash);

    if (typeof $hash == "object" && $hash.length > 0) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top
            }, 500, function(){

            window.location.hash = hash;
        });
    }
}
